import { combineEpicsIsolated } from 'utils/epicRegistry'

import emailTrackingEpics from './EmailTracking/epics'

export default combineEpicsIsolated(emailTrackingEpics)
